import { HttpStatusCode } from "../constants";

export class ServiceError extends Error {
  public constructor(
    message: string,
    public httpStatusCode: HttpStatusCode
  ) {
    super(message);
    Object.setPrototypeOf(this, ServiceError.prototype);
  }
}
